import React from 'react'
import ContactInfo from '../ContactInfo/ContactInfo'
import Hero from '../Hero/Hero'
import Footer from '../Footer/Footer'
import ClientCarousel from '../ClientCarousel/ClientCarousel'

const Homepage = () => {
  return (
    <div>
      <Hero/>
      <ClientCarousel/>
      <ContactInfo/>
      <Footer/>
    </div>
  )
}

export default Homepage